import Vue from 'vue';
import {mapState} from 'vuex';

Vue.mixin({
  data() {
    return {
      themeColor: 'pink',
      darkTheme: false,
      isElectron: process.env.VUE_APP_IS_ELECTRON === 'true'
    };
  },

  computed: {
    ...mapState({
      isTeacher: state => state.isTeacher,
      isStudent: state => state.isStudent
    }),

    profileImg() {
      let gender = Math.floor(Math.random()*2) ? 'men' : 'women';
      let num = Math.floor(Math.random()*100);
      return `https://randomuser.me/api/portraits/${gender}/${num}.jpg`;
    }
  },

  methods: {
    isAllow(roles) {
      roles = [].concat(roles);
      if (this.isTeacher && roles.indexOf('teacher') >= 0) {
        return true;
      }
      if (this.isStudent && roles.indexOf('student') >= 0) {
        return true;
      }
      return false;
    },

    changeRightPage(pageName) {
      this.$store.commit('updateRightPage', pageName);
    }
  }
});
